import { type SourceInfo } from "@recursive-robot/react-jsx-parser";
import { useThunkDispatch } from "../../store";
import { type DiagnosticSeverity } from "../../store/diagnostics/types";
import { reportValidationError } from "../../store/diagnostics/actions";

export function useReportValidationError(sourceInfo: SourceInfo | undefined, componentName: string) {
    const dispatch = useThunkDispatch();

    return (message: string, severity: DiagnosticSeverity = "warning") => {
        // If the sourceInfo object is empty, log the error to the console and short-circuit...
        if (!sourceInfo) {
            console.warn(message);
            return;
        }

        dispatch(
            reportValidationError(
                sourceInfo.fileName,
                sourceInfo,
                {
                    message,
                    type: "validation",
                    componentName,
                    severity
                }
            )
        );
    }
}